/* matcha-rechner — live-berechnung, presets, timer (vanilla js, kein build) */
(function () {
  'use strict';

  const root = document.querySelector('[data-matcha-rechner]');
  if (!root) return;

  const $ = (id) => root.querySelector('#' + id);
  const $$ = (sel) => root.querySelectorAll(sel);

  const presets = {
    usucha: { matcha: 2, water: 70, latte: false, iced: false },
    koicha: { matcha: 4, water: 30, latte: false, iced: false },
    latte:  { matcha: 2, water: 60, latte: true,  iced: false, milk: 200 },
    iced:   { matcha: 2, water: 60, latte: false, iced: true }
  };

  const state = {
    mode: 'usucha',
    matcha: 2,
    water: 70,
    milk: 200,
    iceDilution: 25,
    latte: false,
    iced: false,
    servings: 1
  };

  // ---------- formatters ----------
  const fmt = (n, dec) => {
    const v = Number(n);
    if (Number.isNaN(v)) return '0';
    return v.toFixed(dec ?? 1).replace(/\.0$/, '').replace('.', ',');
  };
  const fmtRound = (n) => Math.round(Number(n) || 0).toString();

  // ---------- preset handling ----------
  function applyPreset(mode) {
    const p = presets[mode];
    if (!p) return;
    state.mode = mode;
    state.matcha = p.matcha;
    state.water = p.water;
    state.latte = p.latte;
    state.iced = p.iced;
    if (typeof p.milk === 'number') state.milk = p.milk;

    $('mr-matcha').value = p.matcha;
    $('mr-water').value = p.water;
    if (typeof p.milk === 'number') $('mr-milk').value = p.milk;

    $$('input[name="mr-mode"]').forEach((el) => { el.checked = el.value === mode; });
    $('mr-milk-field').hidden = !p.latte;
    $('mr-ice-field').hidden = !p.iced;

    calc();
    updateTimerDuration(true);
  }

  // ---------- main calculation ----------
  function calc() {
    const m = Math.max(0.5, parseFloat($('mr-matcha').value) || 0.5);
    const w = Math.max(10, parseFloat($('mr-water').value) || 10);
    const milk = parseFloat($('mr-milk').value) || 200;
    const ice = parseFloat($('mr-ice').value) || 0;
    const servings = parseInt(root.querySelector('input[name="mr-servings"]:checked')?.value || '1', 10);

    state.matcha = m;
    state.water = w;
    state.milk = milk;
    state.iceDilution = ice;
    state.servings = servings;

    // total liquid in ml
    let total = w;
    if (state.latte) total += milk;
    if (state.iced) total = w * (1 + ice / 100);

    const ratio = (m / total) * 1000;

    // outputs
    $('mr-matcha-out').textContent = fmt(m, 1);
    $('mr-water-out').textContent = fmtRound(w);
    $('mr-milk-out').textContent = fmtRound(milk);
    $('mr-ice-out').textContent = fmtRound(ice);

    $('mr-ratio').textContent = fmt(ratio, 1);

    // badge
    let badge = 'Custom';
    if (ratio >= 100) badge = 'Koicha · dicker Tee';
    else if (ratio >= 20) badge = 'Usucha · klassisch';
    else if (ratio >= 12) badge = 'Starker Latte';
    else badge = 'Matcha Latte';
    $('mr-badge').textContent = badge;

    // recipe items
    const ms = (m * servings).toFixed(1).replace(/\.0$/, '').replace('.', ',');
    const ws = Math.round(w * servings);
    $('mr-r-matcha').textContent = ms;
    $('mr-r-water').textContent = ws;
    $('mr-r-milk').textContent = Math.round(milk * servings);
    $('mr-r-milk-wrap').hidden = !state.latte;
    $('mr-r-ice-wrap').hidden = !state.iced;

    // temperature note
    let temp = '70–80\u00a0°C';
    if (ratio >= 100) temp = '80\u00a0°C (etwas heißer für Koicha)';
    if (state.iced) temp = '80\u00a0°C — heiß anrühren, dann auf Eis gießen';
    $('mr-temp-value').innerHTML = temp;

    // steps
    renderSteps(ms, ws, Math.round(milk * servings), ratio);

    // sync mode hint (if user manually changes values, drop preset highlight only when off-grid)
    syncPresetHighlight();
  }

  function renderSteps(ms, ws, milkS, ratio) {
    const list = $('mr-steps-list');
    let html = '';

    if (state.iced && state.latte) {
      html += step(1, `<strong>${ms}\u00a0g</strong> Matcha durch ein feines Sieb in ein hohes Glas geben.`);
      html += step(2, `<strong>${ws}\u00a0ml</strong> heißes Wasser (80\u00a0°C) zugeben und mit Chasen oder Milchaufschäumer zu einer glatten Paste anrühren.`);
      html += step(3, `Glas mit Eiswürfeln füllen.`);
      html += step(4, `<strong>${milkS}\u00a0ml</strong> kalte Milch (Kuh- oder Pflanzenmilch) langsam darübergießen — der zweischichtige Look ist klassisch.`);
      html += step(5, `Vor dem Trinken kurz umrühren. Optional mit Sirup süßen.`);
    } else if (ratio >= 100) {
      html += step(1, `<strong>${ms}\u00a0g</strong> Matcha durch ein feines Sieb in eine warme Chawan geben.`);
      html += step(2, `<strong>${ws}\u00a0ml</strong> Wasser (80\u00a0°C) langsam zugießen.`);
      html += step(3, `Mit dem Chasen <em>langsam</em> in kreisenden Bewegungen kneten — kein Schaum, sondern eine glatte, sirupartige Paste.`);
      html += step(4, `Koicha wird traditionell geteilt. In drei bis vier Schlucken trinken.`);
    } else if (state.latte) {
      html += step(1, `<strong>${ms}\u00a0g</strong> Matcha durch ein feines Sieb in eine Tasse oder Schale geben.`);
      html += step(2, `<strong>${ws}\u00a0ml</strong> heißes Wasser (80\u00a0°C) zugeben und mit Chasen zu einer glatten Paste verrühren.`);
      html += step(3, `<strong>${milkS}\u00a0ml</strong> Milch erhitzen (60–65\u00a0°C) und aufschäumen.`);
      html += step(4, `Milch langsam einfüllen. Optional mit Honig, Agave oder Vanille süßen.`);
    } else if (state.iced) {
      html += step(1, `<strong>${ms}\u00a0g</strong> Matcha durch ein feines Sieb in eine kleine Schale geben.`);
      html += step(2, `<strong>${ws}\u00a0ml</strong> heißes Wasser (80\u00a0°C) zugeben und mit Chasen zu einer glatten Paste aufschlagen.`);
      html += step(3, `Hohes Glas mit Eiswürfeln füllen, Matcha-Paste darübergießen.`);
      html += step(4, `Mit kaltem Wasser auffüllen, kurz umrühren.`);
    } else {
      html += step(1, `<strong>${ms}\u00a0g</strong> Matcha durch ein feines Sieb in die warme Chawan geben.`);
      html += step(2, `Mit einem Schluck heißem Wasser (70–80\u00a0°C) zu einer glatten Paste verrühren.`);
      html += step(3, `Restliches Wasser bis <strong>${ws}\u00a0ml</strong> zugießen. Mit dem Chasen etwa 1 Minute in „M“- oder „W“-Bewegung aufschlagen.`);
      html += step(4, `Sofort genießen, sobald sich ein feiner, gleichmäßiger Schaum gebildet hat.`);
    }

    list.innerHTML = html;
  }

  function step(num, text) {
    return `<li><span class="mr__step-num">${num}</span><span class="mr__step-text">${text}</span></li>`;
  }

  function syncPresetHighlight() {
    // light auto-detect: if values match a preset exactly, mark it; otherwise leave current selection
    for (const [key, p] of Object.entries(presets)) {
      if (
        Math.abs(p.matcha - state.matcha) < 0.01 &&
        Math.abs(p.water - state.water) < 0.5 &&
        p.latte === state.latte &&
        p.iced === state.iced
      ) {
        state.mode = key;
        $$('input[name="mr-mode"]').forEach((el) => { el.checked = el.value === key; });
        return;
      }
    }
  }

  // ---------- timer (60s zubereitungs-timer für die ganze tasse) ----------
  let tInterval = null;
  let tSeconds = 60;
  let tTotal = 60;
  let tRunning = false;
  const C = 276.5;

  function fmtMMSS(s) {
    const m = Math.floor(s / 60);
    const r = s % 60;
    return m + ':' + (r < 10 ? '0' : '') + r;
  }

  function updateTimerDuration(forceReset) {
    const ratio = (state.matcha / state.water) * 1000;
    const newTotal = 60;
    if (forceReset || !tRunning) {
      tTotal = newTotal;
      tSeconds = newTotal;
      $('mr-timer-display').textContent = fmtMMSS(newTotal);
      $('mr-timer-circle').style.strokeDashoffset = '0';
      $('mr-timer-hint').textContent = ratio >= 100
        ? 'Koicha: Mit dem Chasen langsam in kreisenden Bewegungen kneten — kein Schaum, eine glatte Paste.'
        : 'Mit dem Chasen in „M“ oder „W“ aufschlagen, bis ein feiner, gleichmäßiger Schaum entsteht.';
    }
  }

  function toggleTimer() {
    const btn = $('mr-timer-btn');
    if (tRunning) {
      clearInterval(tInterval);
      tRunning = false;
      tSeconds = tTotal;
      $('mr-timer-display').textContent = fmtMMSS(tTotal);
      $('mr-timer-circle').style.strokeDashoffset = '0';
      btn.textContent = 'Aufschlagen starten →';
      btn.classList.remove('mr__timer-btn--running');
      return;
    }
    tRunning = true;
    tSeconds = tTotal;
    btn.textContent = 'Stopp';
    btn.classList.add('mr__timer-btn--running');
    tInterval = setInterval(() => {
      tSeconds--;
      $('mr-timer-display').textContent = fmtMMSS(Math.max(0, tSeconds));
      $('mr-timer-circle').style.strokeDashoffset = (C * ((tTotal - tSeconds) / tTotal)).toString();
      if (tSeconds <= 0) {
        clearInterval(tInterval);
        tRunning = false;
        $('mr-timer-display').textContent = '✓';
        btn.textContent = 'Nochmal →';
        btn.classList.remove('mr__timer-btn--running');
        tSeconds = tTotal;
      }
    }, 1000);
  }

  // ---------- event wiring ----------
  $$('input[name="mr-mode"]').forEach((el) => {
    el.addEventListener('change', () => applyPreset(el.value));
  });

  $$('input[name="mr-servings"]').forEach((el) => {
    el.addEventListener('change', calc);
  });

  ['mr-matcha', 'mr-water', 'mr-milk', 'mr-ice'].forEach((id) => {
    const el = $(id);
    if (el) el.addEventListener('input', calc);
  });

  $('mr-timer-btn').addEventListener('click', toggleTimer);

  // initial render
  applyPreset('usucha');
})();
